import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";

import TerminalMain from "./pages/TerminalMain";
import Contact from "./pages/Contact";
import AiTalk from "./pages/AiTalk";



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/terminal" element={<TerminalMain />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ai-chat" element={<AiTalk />} />
      </Routes>

    </Router>
  );
}

export default App;
